
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: "noticedetail",
components: {
XHeader
},
data(){
return{
notice:{
title:'速度快福建省的框架',
date:'2018-12-12 12:23:40',
author:'小七',
depart:'教务处',
content:'<p>奥斯卡的防滑扣具阿萨德浩丰科技阿萨德斯柯达分开收代理费黑色柳丁发号施令都很疯水电费粉红色领导发话了水电费黄鹤楼啥烦得很烦死了都解放后的设计费华东师范</p>'
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/noticedetail.vue